// Browser ONLY logic. Must have the same exports as server.ts
// See: docs/isomorphic-imports.md

import type { Dependencies } from './types';

import { registerHandler as registerFlowActionHandler } from '~/jet/action-handlers/flow-action';
import { registerHandler as registerCommerceModalActionHandler } from '~/jet/action-handlers/commerce-modal-action';
import { registerHandler as registerCompoundActionHandler } from '~/jet/action-handlers/compound-action';
import { registerHandler as registerOnListItemClickActionHandler } from '~/jet/action-handlers/on-list-item-click-action';
import { registerHandler as registerOpenExternalUrlActionHandler } from '~/jet/action-handlers/open-external-url-action';
import { registerHandler as registerLaunchNativeApplicationHandler } from '~/jet/action-handlers/launch-native-app-action';
import { registerHandler as registerGetPlaybackActionFromQueryHandler } from '~/jet/action-handlers/get-playback-action-from-query';
import { registerHandler as registerGetTrackMetadataActionHandler } from '~/jet/action-handlers/get-track-metadata-action';
import { registerHandler as registerPlayActionHandler } from '~/jet/action-handlers/play-action';
import { registerHandler as registerClearQueueActionHandler } from '~/jet/action-handlers/clear-queue-action';
import { registerHandler as registerPausePlaybackActionHandler } from '~/jet/action-handlers/pause-playback-action';
import { registerHandler as registerPlayQueueItemActionHandler } from '~/jet/action-handlers/play-queue-item-action';
import { registerHandler as registerRemoveQueueItemActionHandler } from '~/jet/action-handlers/remove-queue-item-action';
import { registerHandler as registerResumePlaybackActionHandler } from '~/jet/action-handlers/resume-playback-action';
import { registerHandler as registerSignOutActionHandler } from '~/jet/action-handlers/sign-out-action';
import { registerHandler as registerContextMenuFetchActionHandler } from '~/jet/action-handlers/contextual-menu/fetch-action';
import { registerHandler as registerContextMenuPerformActionHandler } from '~/jet/action-handlers/contextual-menu/perform-action';
import { registerHandler as registerModifyPlaylistActionHandler } from '~/jet/action-handlers/modify-playlist-action';
import { registerHandler as registerSetPersistenceItemActionHandler } from '~/jet/action-handlers/set-persistence-item-action';
import { registerHandler as registerUserComponentsActionHandler } from '~/jet/action-handlers/user-components-action';
import { registerHandler as registerCloseFullScreenPlayerActionHandler } from '~/jet/action-handlers/close-full-screen-player-action';

export type { Dependencies } from './types';

export function registerActionHandlers(dependencies: Dependencies) {
    registerCommerceModalActionHandler(dependencies);
    registerCompoundActionHandler(dependencies);
    registerFlowActionHandler(dependencies);
    registerOpenExternalUrlActionHandler(dependencies);
    registerLaunchNativeApplicationHandler(dependencies);
    registerGetPlaybackActionFromQueryHandler(dependencies);
    registerGetTrackMetadataActionHandler(dependencies);
    registerPlayActionHandler(dependencies);
    registerClearQueueActionHandler(dependencies);
    registerPausePlaybackActionHandler(dependencies);
    registerPlayQueueItemActionHandler(dependencies);
    registerRemoveQueueItemActionHandler(dependencies);
    registerResumePlaybackActionHandler(dependencies);
    registerSignOutActionHandler(dependencies);
    registerOnListItemClickActionHandler(dependencies);
    registerContextMenuFetchActionHandler(dependencies);
    registerContextMenuPerformActionHandler(dependencies);
    registerModifyPlaylistActionHandler(dependencies);
    registerSetPersistenceItemActionHandler(dependencies);
    registerUserComponentsActionHandler(dependencies);
    registerCloseFullScreenPlayerActionHandler(dependencies);
}
